import React from 'react'
import LogoRecoveryCom from '@/components/LogoRecoveryCom'
import LogoRecoveryLuxury from '@/components/LogoRecoveryLuxury'
import LogoRecoveryUK from '@/components/LogoRecoveryUK'
import LogoRecoveryEatingDisorders from '@/components/LogoRecoveryEatingDisorders/LogoRecoveryEatingDisorders'
import LogoRecoverySoberLiving from '@/components/LogoRecoverySoberLiving/LogoRecoverySoberLiving'
import LogoRecoveryProviders from '@/components/LogoRecoveryProviders/LogoRecoveryProviders'

const RehabPathLogo = ({
  isLuxury,
  isUnitedKingdomPage,
  isEatingDisorders,
  isSoberLiving,
  isProviders
}) => {
  if (isLuxury) {
    return <LogoRecoveryLuxury />
  }

  if (isUnitedKingdomPage) {
    return <LogoRecoveryUK />
  }

  if (isEatingDisorders) {
    return <LogoRecoveryEatingDisorders />
  }

  if (isSoberLiving) {
    return <LogoRecoverySoberLiving />
  }

  if (isProviders) {
    return <LogoRecoveryProviders />
  }

  return <LogoRecoveryCom className="text-primary-900" />
}

export default RehabPathLogo
